import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import SearchForm from '../../components/SearchForm/SearchForm.tsx';
import Results from '../../components/Results/Results.tsx';

const propTypes = {
  handleSearchTermChange: PropTypes.func,
  handleSortChange: PropTypes.func,
  handlePageChange: PropTypes.func,
  results: PropTypes.array,
  searchTerm: PropTypes.string,
  currentPage: PropTypes.number,
};

export default function AppLayout(
  props: InferProps<typeof propTypes>,
): JSX.Element {
  const { handleSearchTermChange, handleSortChange, handlePageChange, results, searchTerm, currentPage } =
    props;

  return (
    <div className="applayout">
      <SearchForm
        defaultValue={searchTerm}
        handleChange={handleSearchTermChange}
      />
      <Results
        results={results}
        searchTerm={searchTerm}
        currentPage={currentPage}
        handleChange={handleSortChange}
        handlePageChange={handlePageChange}
      />
    </div>
  );
}
